<template>
  <component
      :is="to !== null ? RouterLink : 'div'"
      :to="to"
      class="btn group inline-flex items-center gap-2"
      :class="{
    'opacity-50 cursor-not-allowed pointer-events-none': disabled
  }"
      @click.stop="handleClick"
      role="button"
      tabindex="0"
      @keydown.enter.prevent="handleClick"
      @keydown.space.prevent="handleClick"
  >
    <!-- Left Icon -->
    <span
        v-if="left"
        :class="[
        typeof left === 'string' ? `bi ${left}` : '',
        'w-5 h-5',
        'group-[.btn-xs]:w-3 group-[.btn-xs]:h-3',
        'group-[.btn-sm]:w-4 group-[.btn-sm]:h-4',
        'group-[.btn-lg]:w-6 group-[.btn-lg]:h-6',
        'group-[.btn-xl]:w-7 group-[.btn-xl]:h-7',
        'flex items-center justify-center'
      ]"
    >
      <component v-if="typeof left !== 'string'" :is="left"/>
    </span>

    <!-- Button Label -->
    <span class="whitespace-nowrap">
      <slot>Button</slot>
    </span>

    <!-- Right Icon -->
    <span
        v-if="right"
        :class="[
        typeof right === 'string' ? `bi ${right}` : '',
        'w-5 h-5',
        'group-[.btn-xs]:w-3 group-[.btn-xs]:h-3',
        'group-[.btn-sm]:w-4 group-[.btn-sm]:h-4',
        'group-[.btn-lg]:w-6 group-[.btn-lg]:h-6',
        'group-[.btn-xl]:w-7 group-[.btn-xl]:h-7',
        'flex items-center justify-center'
      ]"
    >
      <component v-if="typeof right !== 'string'" :is="right"/>
    </span>
  </component>
</template>

<script setup>
import {RouterLink} from 'vue-router'

const emit = defineEmits(['click'])

function handleClick(event) {
  if (props.disabled) return
  emit('click', event)
}

const props = defineProps({
  left: {type: [String, Object, Function], default: null},
  right: {type: [String, Object, Function], default: null},
  to: {type: [String, Object], default: null},
  disabled: {type: Boolean, default: false} // NEW
})

</script>